.link {
    color: inherit;
    text-decoration: underline;
}

.link:hover {
    color: black;
}
